function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 19 15",
    className: "icon",
    style: {
      "height": "1em",
      "width": "1.26667em"
    }
  }, props), React.createElement("g", {
    style: {
      "fillRule": "evenodd",
      "clipRule": "evenodd",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    }
  }, React.createElement("path", {
    d: "M15.978,4.97L15.978,3.97C15.978,3.418 15.531,2.97 14.978,2.97L7.478,2.97L6.278,1.37C6.089,1.118 5.793,0.97 5.478,0.97L1.978,0.97C1.426,0.97 0.978,1.418 0.978,1.97L0.978,12.97C0.978,13.522 1.426,13.97 1.978,13.97",
    style: {
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "1.5px"
    }
  }), React.createElement("path", {
    d: "M1.987,13.942C2.615,14.024 3.208,13.633 3.38,13.024L5.144,5.781C5.283,5.3 5.724,4.97 6.225,4.97L16.628,4.97C16.978,4.97 17.308,5.132 17.521,5.409C17.734,5.686 17.806,6.047 17.716,6.385L16.066,13.135C15.935,13.627 15.488,13.97 14.978,13.97L2.151,13.97",
    style: {
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "1.5px"
    }
  })));
};

export default __webpack_public_path__ + "static/media/folder-open-outline.c438e114.svg";
export { SvgComponent as ReactComponent };